import { promiseAction } from '../../utils/store';

export const SETTINGS_ACTION_TYPES = {
  LOAD_SETTINGS: 'settings/LOAD_SETTINGS',
  SET_SETTINGS: 'settings/SET_SETTINGS',
  EDIT_SETTINGS: 'settings/EDIT_SETTINGS',
  SET_SETTINGS_LOADING: 'settings/SET_SETTINGS_LOADING',
};

export const loadSettings = () => {
  return {
    type: SETTINGS_ACTION_TYPES.LOAD_SETTINGS,
  }
};

export const setSettings = (payload) => {
  return {
    type: SETTINGS_ACTION_TYPES.SET_SETTINGS,
    payload,
  }
};

export const editSettings = promiseAction(SETTINGS_ACTION_TYPES.EDIT_SETTINGS);

export const setSettingsLoading = (payload) => {
  return {
    type: SETTINGS_ACTION_TYPES.SET_SETTINGS_LOADING,
    payload,
  }
};
